import React from 'react';
import { LayersIcon, FileTextIcon, RepeatIcon, ZapIcon, RefreshCwIcon } from 'lucide-react';
import { featureHighlights, features } from '../data/content';
import { SectionHeading } from './SectionHeading';
const icons = [LayersIcon, FileTextIcon, RepeatIcon, ZapIcon, RefreshCwIcon];
export function WhatYouGet() {
  return <section aria-labelledby="get-title" className="bg-paper" data-id="element-374" data-mp="q37kiv0tarf9">
      <div className="mx-auto max-w-content px-5 py-20 sm:px-8 lg:py-28" data-id="element-375" data-mp="1drgzbczlyeww">
        <SectionHeading id="get-title" title="Alles, was du brauchst, um loszulegen" intro="Mit dem GROSSEN EVANGELISATIONS-PAKET erhältst du sofortigen digitalen Zugang zu:" data-id="element-376" data-mp="1duczz92ubhp1" />
        <div className="mt-14 grid gap-5 md:grid-cols-2" data-id="element-377" data-mp="1910lhrrvkra0">
          {featureHighlights.map(f => <div key={f.title} className="flex flex-col rounded-[28px] bg-cream p-8 sm:p-10" data-id="element-378" data-mp="1wr4opy15ip0h">
              <span className="font-display text-[80px] leading-[0.85] text-coral" data-id="element-379" data-mp="21hbbrtg0m1gm">{f.value}</span>
              <h3 className="mt-4 hyphens-auto text-xl font-extrabold uppercase tracking-[0.06em] text-navy" data-id="element-380" data-mp="2vfkgl004tumc">{f.title}</h3>
              <p className="mt-3 leading-relaxed text-ink-soft" data-id="element-381" data-mp="2qhioxqon4mz9">{f.text}</p>
            </div>)}
        </div>
        <ul className="mt-12 grid gap-10 sm:grid-cols-2 lg:grid-cols-5" data-id="element-382" data-mp="356f385haiw8b">
          {features.map((f, i) => {
          const Icon = icons[i];
          return <li key={f.title} data-id="element-383" data-mp="3e5sdv1h5hqum" data-mpi={i}>
                <span className="flex h-12 w-12 items-center justify-center rounded-full bg-leaf-wash text-leaf-deep" data-id="element-384" data-mp="3e4qri0uophxl">
                  <Icon className="h-5 w-5" aria-hidden="true" data-id="element-385" data-mp="399bgdgo2a04v" />
                </span>
                <h3 className="mt-4 hyphens-auto font-extrabold uppercase tracking-[0.04em] text-navy" data-id="element-386" data-mp="3o3zkorhq6siw">{f.title}</h3>
                <p className="mt-2 hyphens-auto leading-relaxed text-ink-soft" data-id="element-387" data-mp="3j3bqxy243xkz">
                  {f.text}
                  {f.strong && <strong className="font-bold text-navy" data-id="element-388" data-mp="1ordme9eqzpvf"> {f.strong}</strong>}
                </p>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}